export default __webpack_public_path__ + "static/media/nurse.2aa02a96.jpg";